import React, { useMemo } from 'react';
import TableContainer from 'components/Common/TableContainer';
import { Card, CardBody, CardTitle } from 'reactstrap';

const dummyPurchaseItems = [
  {
    id: '1',
    invoice: { invoiceNumber: 'INV001', invoiceDate: '2025-01-10' },
    batchNumber: 'B001',
    quantity: 1000,
    rate: 0.5,
  },
  {
    id: '2',
    invoice: { invoiceNumber: 'INV002', invoiceDate: '2025-03-15' },
    batchNumber: 'B002',
    quantity: 500,
    rate: 0.55,
  },
];

const PurchaseHistoryTable = () => {
  const columns = useMemo(
    () => [
      {
        header: 'Invoice #',
        accessorKey: 'invoice.invoiceNumber',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Date',
        accessorKey: 'invoice.invoiceDate',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Batch',
        accessorKey: 'batchNumber',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Quantity',
        accessorKey: 'quantity',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Rate',
        accessorKey: 'rate',
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    [],
  );

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Purchase History</CardTitle>
        <TableContainer
          columns={columns}
          data={dummyPurchaseItems}
          isGlobalFilter={false}
          tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-borderless"
          theadClass="table-light"
          paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
          paginationClass="pagination"
        />
      </CardBody>
    </Card>
  );
};

export default PurchaseHistoryTable;
